import { useEffect, useState } from 'react';

type Listener = (message: string | null) => void;
const listeners = new Set<Listener>();
const noticeListeners = new Set<Listener>();
let timer = 0;
let current: string | null = null;

/** A message that stays until it's cleared (null), such as "Updating…"; a toast shows over it. */
export function notice(message: string | null) {
  current = message;
  for (const l of noticeListeners) l(message);
}

/** Shows a short message at the bottom for a few seconds. */
export function toast(message: string) {
  clearTimeout(timer);
  for (const l of listeners) l(message);
  timer = window.setTimeout(() => {
    for (const l of listeners) l(null);
  }, 3200);
}

export function ToastHost() {
  const [message, setMessage] = useState<string | null>(null);
  const [standing, setStanding] = useState<string | null>(current);
  useEffect(() => {
    listeners.add(setMessage);
    noticeListeners.add(setStanding);
    return () => {
      listeners.delete(setMessage);
      noticeListeners.delete(setStanding);
    };
  }, []);
  const shown = message ?? standing;
  return (
    <div aria-live="polite" role="status">
      {shown && <div className="toast">{shown}</div>}
    </div>
  );
}
